import { AxiosResponse } from 'axios'

import { http } from '@/utils/http'

import { LoginModel, LoginResponse } from '../models/Login.model'
import {
  RegisterCheckPoliciesModel,
  RegisterCodeModel,
  RegisterFinishRequestModel,
  RegisterFormData,
  RegisterPhoneModel,
  RegisterResponse,
} from '../models/Register.model'
import { UserProfileResponse } from '../models/User.model'

class AuthService {
  async login(form: LoginModel): Promise<LoginResponse> {
    const url = form.step
      ? form.step === 'verify'
        ? '/step/verify'
        : form.step === 'finish'
          ? '/step/finish'
          : '/step/verify_2fa'
      : ''

    const res = await http.post<LoginModel, AxiosResponse<LoginResponse>>(
      `/auth/auth${url}`,
      form,
    )
    return res.data
  }

  async registration(form: RegisterFormData): Promise<RegisterResponse> {
    const res = await http.post<
      RegisterFormData,
      AxiosResponse<RegisterResponse>
    >(`/auth/registration`, form)
    return res.data
  }

  async checkPolicies(
    form: RegisterCheckPoliciesModel,
  ): Promise<RegisterResponse> {
    const res = await http.post<
      RegisterCheckPoliciesModel,
      AxiosResponse<RegisterResponse>
    >(`/auth/registration/step/check_policies`, form)
    return res.data
  }

  async emailVerify(form: RegisterCodeModel): Promise<RegisterResponse> {
    const res = await http.post<
      RegisterCodeModel,
      AxiosResponse<RegisterResponse>
    >(`/auth/registration/step/email_verify`, form)
    return res.data
  }
  async smsVerify(form: RegisterCodeModel): Promise<RegisterResponse> {
    const res = await http.post<
      RegisterCodeModel,
      AxiosResponse<RegisterResponse>
    >(`/auth/registration/step/sms_verify`, form)
    return res.data
  }

  async enterPhone(form: RegisterPhoneModel): Promise<RegisterResponse> {
    const res = await http.post<
      RegisterPhoneModel,
      AxiosResponse<RegisterResponse>
    >(`/auth/registration/step/enter_phone`, form)
    return res.data
  }

  async registerFinish(
    form: RegisterFinishRequestModel,
  ): Promise<RegisterFinishRequestModel> {
    const res = await http.post<
      RegisterFinishRequestModel,
      AxiosResponse<RegisterFinishRequestModel>
    >(`/auth/registration/step/finish`, form)
    return res.data
  }

  async getUser(): Promise<UserProfileResponse> {
    const res = await http.get(`/auth/user`)
    return res.data
  }
}

export default new AuthService()
